import { atom } from "jotai";

export const emailAtom = atom<string | null>(null);
